import React, { useState } from 'react';
import '../assets/styles/PayPalDonateButton.css';

const PayPalDonateButton = () => {
    const [showThankYou, setShowThankYou] = useState(false);

    const handleDonateClick = () => {
        const paypalLink = process.env.REACT_APP_PAYPAL_DONATE_URL;
        if (!paypalLink) {
            setShowThankYou(true);
            setTimeout(() => setShowThankYou(false), 3000);
            return; // No PayPal configured — button shows "Coming Soon" (see below)
        }
        window.open(paypalLink, '_blank');
        setShowThankYou(true);
        setTimeout(() => setShowThankYou(false), 5000);
    };

    const isConfigured = !!process.env.REACT_APP_PAYPAL_DONATE_URL;

    return (
        <div className="paypal-donate-widget">
            <div className="donate-header">
                <span className="donate-icon">💝</span>
                <h3>Support DadBucks</h3>
            </div>
            <p className="donate-description">
                Love using DadBucks? Help us keep it free and ad-free for families everywhere!
            </p>
            <button
                className="btn-donate"
                onClick={handleDonateClick}
                aria-label={isConfigured ? "Donate via PayPal" : "Donations coming soon"}
                disabled={!isConfigured}
                style={!isConfigured ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
            >
                <svg
                    className="paypal-logo"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M20.067 8.478c.492.88.556 2.014.3 3.327-.74 3.806-3.276 5.12-6.514 5.12h-.5a.805.805 0 0 0-.794.68l-.04.22-.63 3.993-.028.15a.806.806 0 0 1-.795.68H7.723a.483.483 0 0 1-.477-.558L9.344 7.99a.97.97 0 0 1 .957-.82h4.121c1.194 0 2.138.146 2.822.44.854.37 1.441.995 1.823 1.868z" />
                    <path d="M9.344 7.99a.97.97 0 0 1 .957-.82h4.121c1.194 0 2.138.146 2.822.44.854.37 1.441.995 1.823 1.868.492.88.556 2.014.3 3.327-.74 3.806-3.276 5.12-6.514 5.12h-.5a.805.805 0 0 0-.794.68l-.04.22-.63 3.993-.028.15a.806.806 0 0 1-.795.68H7.723a.483.483 0 0 1-.477-.558L9.344 7.99z" opacity=".7" />
                    <path d="M13.513 11.14c.393 0 .732.024 1.017.074a5.367 5.367 0 0 1 .814.18c.244.072.455.158.632.257.177.1.318.21.424.332a1.08 1.08 0 0 1 .213.37c.043.134.065.28.065.436 0 .395-.094.765-.283 1.11-.189.344-.455.644-.798.9-.343.255-.751.455-1.224.6-.473.144-.988.216-1.545.216h-.5a.805.805 0 0 0-.794.68l-.04.22-.63 3.993-.028.15a.806.806 0 0 1-.795.68H7.723a.483.483 0 0 1-.477-.558l.896-5.68a.97.97 0 0 1 .957-.82h4.414z" opacity=".5" />
                </svg>
                {isConfigured ? 'Donate with PayPal' : 'Donations Coming Soon'}
            </button>
            {showThankYou && (
                <div className="thank-you-message">
                    <span className="thank-you-icon">🙏</span>
                    <p>Thank you for your support!</p>
                </div>
            )}
            <p className="donate-footer">
                Every contribution helps us improve DadBucks for families like yours.
            </p>
        </div>
    );
};

export default PayPalDonateButton;
